module.exports = __webpack_public_path__ + "img/users-icon.d775036a.svg";